import type { Cadence } from './reportEnums.constants';

/** User-facing cadence labels (Studio parity; API value remains `adhoc`). */
export const CADENCE_LABELS: Record<Cadence, string> = {
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  adhoc: 'Joint Operating Committee (JOC)',
};

/**
 * @param cadence - Stored cadence enum value.
 * @returns Display label for UI and print headers.
 */
export const formatCadenceLabel = (cadence: Cadence | string): string => {
  if (cadence === 'monthly' || cadence === 'quarterly' || cadence === 'adhoc') {
    return CADENCE_LABELS[cadence];
  }
  return cadence;
};
